import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeliveryStatusAttributeFilter } from '../../../models/delivery-status-attribute-filter';
import { DeliveryStatusEnum } from '../../../../../../models/enums/delivery-status.enum';

@Component({
  selector: 'jhi-delivery-status-filter',
  templateUrl: './delivery-status-filter.component.html',
  styleUrls: ['./delivery-status-filter.component.scss'],
})
export class DeliveryStatusFilterComponent {
  @Input() filter!: DeliveryStatusAttributeFilter;
  @Output() filterChange = new EventEmitter<DeliveryStatusAttributeFilter>();

  DELIVERY_STATUS = DeliveryStatusEnum;
}
